export default "__VITE_ASSET__BU2c3MbO__"